// react_frontend/src/Components/Partials/Footer.js
import React, { useEffect, useState } from "react";
import { AxiosAuthInstance } from "../../AxiosInterceptors";

// RSuite Components
import { Badge } from "rsuite";
import "rsuite/dist/rsuite.min.css";

const Footer = () => {
  const [companyName, setCompanyName] = useState("SSM-Lumen");

  useEffect(() => {
    AxiosAuthInstance.get("company/profile")
      .then((response) => {
        setCompanyName(
          response?.data?.company?.company_name || "SSM-Lumen"
        );
      })
      .catch((error) => {
        console.error("Error fetching company profile:", error);
        setCompanyName("SSM-Lumen");
      });
  }, []);

  return (
    <footer
      className="appFooter"
      style={{
        backgroundColor: "#2c3e50",
        color: "white",
        borderTop: "1px solid #34495e",
        padding: "16px 0",
        marginTop: "auto",
        fontSize: "14px",
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <div className="container-fluid px-4">
        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
          {/* Left: Copyright */}
          <div className="mb-2 mb-md-0 text-center text-md-start">
            <span style={{ opacity: 0.9 }}>
              © {new Date().getFullYear()}{" "}
              <strong>{companyName}</strong> | Version{" "}
              <Badge color="blue" size="sm" style={{ fontSize: "0.75em" }}>
                2.0.1
              </Badge>
            </span>
          </div>

          {/* Right: Developer Credit */}
          <div className="text-center text-md-end">
            <span style={{ opacity: 0.8 }}>
              Powered by{" "}
              <a
                href="https://www.softsolutionmedia.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#3498db",
                  textDecoration: "none",
                  fontWeight: "500",
                }}
                onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
                onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
              >
                Soft Solution Media
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;